
function hostTitle() {
  if (window.location.href.toLowerCase().includes('proactiveiq.com')) 
    return "Proactive IQ";
  else
    return "Telemetry";
};

function domainName() {
  if (window.location.href.toLowerCase().includes('proactiveiq.com'))
    return "proactiveiq-";
  else
    return "";
};

function isHostProactive() {
  return window.location.href.toLowerCase().includes('proactiveiq.com');
};

export { isHostProactive, hostTitle, domainName };



// WEBPACK FOOTER //
// ./src/config/ui.js